import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconName", "tooltip"];

/** @jsx jsx */

/* eslint import/namespace: ['error', { allowComputed: true }] */
import { jsx } from '@emotion/react';
import { createTooltip } from '@flowio/react-tooltip';
import * as icons from '@flowio/react-icons';
import pascalCase from '../utilities/pascalCase';

function has(object, property) {
  return property in object;
}

var Icon = function Icon(_ref) {
  var iconName = _ref.iconName,
      tooltip = _ref.tooltip,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  if (iconName == null) {
    return null;
  }

  var ElementType;
  var key = pascalCase(iconName);

  if (has(icons, key)) {
    ElementType = icons[key];
  }

  if (ElementType == null) {
    return null;
  }

  var iconElement = jsx(ElementType, _objectSpread(_objectSpread({}, unhandledProps), {}, {
    css: {
      display: 'inline-block',
      fill: 'currentColor',
      userSelect: 'none',
      verticalAlign: 'middle'
    }
  }));
  return tooltip == null ? iconElement : createTooltip(tooltip, {
    overrideProps: {
      trigger: iconElement
    }
  });
};

export default Icon;